/** Align with backend constants/permissions.js and mst_submodules.submodule_slug */
export const TOS_FROS_CONTROL_SUBMODULE_SLUG = "tos-fros-control";
export const TOS_FROS_SUBMODULE_SLUG = "tos-fros";
